import { FC } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const Users01: FC<IconProps> = ({
  fill = "none",
  height = "18px",
  strokeWidth = "1",
  viewBox = "0 0 18 18",
  width = "18px",
  ...props
}) => (
  <Icon fill={fill} height={height} viewBox={viewBox} width={width} {...props}>
    <path
      d="M15.685 15.2569V13.8665C15.685 12.5707 14.7762 11.482 13.5462 11.1733M11.0508 2.9453C12.0959 3.35783 12.8332 4.35696 12.8332 5.524C12.8332 6.69104 12.0959 7.69017 11.0508 8.1027M12.1202 15.2569C12.1202 13.9612 12.1202 13.3134 11.9031 12.8023C11.6137 12.1209 11.0585 11.5796 10.3597 11.2973C9.83564 11.0857 9.17125 11.0857 7.84245 11.0857H5.70356C4.37476 11.0857 3.71036 11.0857 3.18628 11.2973C2.48749 11.5796 1.93231 12.1209 1.64287 12.8023C1.42578 13.3134 1.42578 13.9612 1.42578 15.2569M9.62486 5.524C9.62486 7.05981 8.34804 8.30483 6.773 8.30483C5.19797 8.30483 3.92115 7.05981 3.92115 5.524C3.92115 3.98819 5.19797 2.74316 6.773 2.74316C8.34804 2.74316 9.62486 3.98819 9.62486 5.524Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M15.685 15.2569V13.8665C15.685 12.5707 14.7762 11.482 13.5462 11.1733M11.0508 2.9453C12.0959 3.35783 12.8332 4.35696 12.8332 5.524C12.8332 6.69104 12.0959 7.69017 11.0508 8.1027M12.1202 15.2569C12.1202 13.9612 12.1202 13.3134 11.9031 12.8023C11.6137 12.1209 11.0585 11.5796 10.3597 11.2973C9.83564 11.0857 9.17125 11.0857 7.84245 11.0857H5.70356C4.37476 11.0857 3.71036 11.0857 3.18628 11.2973C2.48749 11.5796 1.93231 12.1209 1.64287 12.8023C1.42578 13.3134 1.42578 13.9612 1.42578 15.2569M9.62486 5.524C9.62486 7.05981 8.34804 8.30483 6.773 8.30483C5.19797 8.30483 3.92115 7.05981 3.92115 5.524C3.92115 3.98819 5.19797 2.74316 6.773 2.74316C8.34804 2.74316 9.62486 3.98819 9.62486 5.524Z"
    stroke="#111A18"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>;
